import { useEffect, type ReactElement } from 'react';

const scrollAppContentToTop = (): void => {
  const scrollContainer = document.querySelector('.main__content');

  if (scrollContainer instanceof HTMLElement) {
    scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

export const ScrollResetOnNavigation = (): ReactElement | null => {
  useEffect(() => {
    scrollAppContentToTop();

    const history = window.history;
    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    const notifyScrollReset = (): void => {
      scrollAppContentToTop();
    };

    history.pushState = ((...args: Parameters<History['pushState']>): void => {
      originalPushState(...args);
      notifyScrollReset();
    }) as History['pushState'];

    history.replaceState = ((...args: Parameters<History['replaceState']>): void => {
      originalReplaceState(...args);
      notifyScrollReset();
    }) as History['replaceState'];

    window.addEventListener('popstate', notifyScrollReset);

    return (): void => {
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
      window.removeEventListener('popstate', notifyScrollReset);
    };
  }, []);

  return null;
};
